import type { ComponentStatus } from '../api/statusApi';
import { STATUS_META } from '../statusMeta';
import { IconCheck, IconWrench } from './icons';
import './OverallStatusBanner.css';

interface Props {
  status: ComponentStatus;
  generatedAt: string;
  isStale: boolean;
  /** Components with `monitored: false`; they can't vouch for "all systems". */
  unmonitoredCount: number;
  componentCount: number;
}

const SUMMARY: Record<ComponentStatus, string> = {
  operational: 'All systems operational',
  degraded_performance: 'Some systems are experiencing degraded performance',
  partial_outage: 'Some systems are experiencing a partial outage',
  major_outage: 'Some systems are experiencing a major outage',
  under_maintenance: 'Scheduled maintenance in progress',
};

export function OverallStatusBanner({ status, generatedAt, isStale, unmonitoredCount, componentCount }: Props) {
  const meta = STATUS_META[status];
  const Icon = status === 'under_maintenance' ? IconWrench : IconCheck;
  const summary =
    status === 'operational' && unmonitoredCount > 0 ? 'All monitored systems operational' : SUMMARY[status];

  return (
    <div className="overall-banner" style={{ background: meta.color }}>
      <div className="container overall-banner__inner">
        <span className="overall-banner__icon">
          <Icon width={22} height={22} stroke="#fff" />
        </span>
        <div>
          <p className="overall-banner__summary">{summary}</p>
          {unmonitoredCount > 0 && (
            <p className="overall-banner__timestamp">
              {unmonitoredCount} of {componentCount} components are not monitored yet
            </p>
          )}
          <p className="overall-banner__timestamp">
            Last checked {new Date(generatedAt).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
            })}
            {isStale && ' — updates may be delayed'}
          </p>
        </div>
      </div>
    </div>
  );
}
